import React from 'react';
import { useForm } from 'react-hook-form';
import { useCreateProduct } from '~/hooks/products';
import styles from './create-product.module.scss';

const CreateProduct = (
  {
    onSuccess,
    close,
  }: {
    onSuccess: (productId: string) => void;
    close: () => void;
  },
) => {
  const { register, handleSubmit } = useForm({ defaultValues: { title: '' } });
  const { mutateAsync: createProduct, isLoading } = useCreateProduct();

  const submit = async (data: any) => {
    const created = await createProduct({ title: data.title });
    if (created?.product?._id) onSuccess(created.product._id);
  };

  return (
    <div className={styles.createProduct}>
      <div className={styles.header}>
        <h2>Créer un produit</h2>
      </div>
      <form onSubmit={handleSubmit(submit)}>
        <div className={styles.field}>
          <label>Nom</label>
          {/* simple input to avoid introducing new shared field components */}
          <input
            type='text'
            {...register('title', { required: true })}
          />
        </div>
        <div className={styles.actions}>
          <button type='button' className='secondary' onClick={close}>Annuler</button>
          <button type='submit' disabled={isLoading}>Créer</button>
        </div>
      </form>
    </div>
  );
};

export default CreateProduct;
